import { BrowserRouter, Route, Routes} from 'react-router-dom';
import Feeds from "./Feeds/Feeds";
function App() {
  const basename = "/";  
  return (
    <BrowserRouter basename={basename}>
          <Routes>
            <Route path='/' element={<Feeds/>} key="/" exact={true}/>
            <Route path='*' element={<Feeds/>} key="*" />
            <Route path='/servicios/feedsnoticias/feeds' element={<Feeds/>} key="feeds" exact={true}/>
          </Routes>
      </BrowserRouter>
  );
}

export default App;
